import React, { useState } from 'react';
import { Phone, FileText } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';
import QuoteModal from './QuoteModal';
import { useSettings } from '../hooks/useSettings';

const FinalCTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { settings } = useSettings();

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(companyInfo.whatsappMessage);
    window.open(`https://wa.me/${settings.whatsappPhone}?text=${message}`, '_blank');
  };

  return (
    <section className="py-20 bg-gradient-to-br from-[#071028] via-[#0077C8] to-[#1FA2FF] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center space-y-8">
          {/* Heading */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
              Pronto para Marcar a Sua Mudança?
            </h2>
            <p className="text-xl text-gray-200">
              Peça o seu orçamento gratuito agora e tenha resposta em 1 hora!
            </p>
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              onClick={handleWhatsAppClick}
              size="lg"
              className="bg-white text-[#071028] hover:bg-gray-100 font-bold text-lg px-10 py-7 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-2xl group"
            >
              <Phone className="w-6 h-6 mr-3 text-[#1FA2FF] group-hover:rotate-12 transition-transform" />
              Contactar via WhatsApp
            </Button>
            <Button
              onClick={() => setIsModalOpen(true)}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#071028] font-bold text-lg px-10 py-7 rounded-xl transition-all duration-300 hover:scale-105 group"
            >
              <FileText className="w-6 h-6 mr-3 group-hover:scale-110 transition-transform" />
              Preencher Formulário
            </Button>
          </div>

          {/* Trust Elements */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-white text-sm pt-8">
            <div className="flex items-center gap-2">
              <span className="text-[#1FA2FF] text-xl">✓</span>
              <span>Orçamento gratuito</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[#1FA2FF] text-xl">✓</span>
              <span>Sem compromisso</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-[#1FA2FF] text-xl">✓</span>
              <span>Resposta rápida</span>
            </div>
          </div>
        </div>
      </div>

      <QuoteModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default FinalCTA;
